import { render, staticRenderFns } from "./mainVentilation.vue?vue&type=template&id=91c3c960"
import script from "./mainVentilation.vue?vue&type=script&lang=js"
export * from "./mainVentilation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports